import React, { type FormEvent, useEffect, useState } from 'react';
import { Button, Form } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { FireDepartmentService, FirefighterService } from '../../../../services';
import { useAppSelector } from '../../../../store/hooks';
import { selectDepartment, selectIsSuperAdmin } from '../../../../store/reducers';
import type { FireDepartment } from '../../../../types';
import { SimpleBox } from '../../../atoms';

export function AddMember(): React.JSX.Element {
  const userDepartment = useAppSelector(selectDepartment);
  const isSuperAdmin = useAppSelector(selectIsSuperAdmin);

  const [firstname, setFirstname] = useState('');
  const [lastname, setLastname] = useState('');
  const [departments, setDepartments] = React.useState<FireDepartment[]>([]);
  const [selectedDepartment, setSelectedDepartment] = React.useState<string>('undefined');

  const handleAddMember = async (): Promise<void> => {
    if (firstname === '' || lastname === '' || (isSuperAdmin && selectedDepartment === 'undefined')) {
      toast.warning('Nicht alle Felder sind ausgefüllt ‼️');

      return;
    }

    const addFirefighterResponse = await FirefighterService.addFirefighter({
      firstname,
      lastname,
      department: userDepartment ? userDepartment.id : selectedDepartment,
    });
    if (addFirefighterResponse.error) {
      toast.error('Fehler beim Erstellen des neuen Mitgliedes 😩');

      return;
    }

    setFirstname('');
    setLastname('');
    toast.success('Mitglied hinzugefügt ✅');
  };

  const handleSubmit = (e: FormEvent<HTMLFormElement>): void => {
    e.preventDefault();
  };

  const handleKeyPress = (key: string): void => {
    if (key === 'Enter') {
      handleAddMember();
    }
  };

  const loadFireDepartments = async (): Promise<void> => {
    const fireDepartmentResponse = await FireDepartmentService.getAllFireDepartments();
    if (fireDepartmentResponse.error) {
      toast.error('Fehler beim Laden der Feuerwehren 😩');
      console.log(fireDepartmentResponse.message);

      return;
    }
    setDepartments(fireDepartmentResponse.data as FireDepartment[]);
  };

  useEffect(() => {
    if (isSuperAdmin) {
      loadFireDepartments().then(() => {});
    }
  }, []);

  return (
    <div className='container mt-10'>
      <div className='row'>
        <div className='col-12'>
          <SimpleBox>
            <h4>Mitglied hinzufügen</h4>
            <Form onSubmit={handleSubmit}>
              {isSuperAdmin && departments && (
                <Form.Group className='mt-4 mb-3' controlId='formGroupDepartment'>
                  <div className='row'>
                    <div className='col-12'>
                      <Form.Select
                        value={selectedDepartment}
                        onChange={(e) => setSelectedDepartment(e.target.value as string)}
                      >
                        <option value='undefined'>Abteilung auswählen</option>
                        {departments.map((fd) => (
                          <option value={fd.id}>{fd.name}</option>
                        ))}
                      </Form.Select>
                    </div>
                  </div>
                </Form.Group>
              )}
              <Form.Group className='mt-4 mb-3' controlId='formGroupName'>
                <div className='row'>
                  <div className='col-sm-12 col-md-6'>
                    <Form.Control
                      type='text'
                      placeholder='Vorname'
                      value={firstname}
                      onChange={(e) => setFirstname(e.target.value)}
                      onKeyDown={(e) => handleKeyPress(e.key)}
                    ></Form.Control>
                  </div>
                  <div className='col-sm-12 col-md-6 mt-3 mt-sm-3 mt-md-0'>
                    <Form.Control
                      type='text'
                      placeholder='Nachname'
                      value={lastname}
                      onChange={(e) => setLastname(e.target.value)}
                      onKeyDown={(e) => handleKeyPress(e.key)}
                    ></Form.Control>
                  </div>
                </div>
              </Form.Group>

              <Form.Group controlId='formGroupAdd'>
                <div className='row'>
                  <div className='col-12'>
                    <Button onClick={() => handleAddMember()}>Hinzufügen</Button>
                  </div>
                </div>
              </Form.Group>
            </Form>
          </SimpleBox>
        </div>
      </div>
    </div>
  );
}
